<div class="flex items-center gap-1">
  @if (addons()?.icon) {
    <ui-icon [icon]="addons()!.icon!" [size]="16" />
  }
  <label for="form-field-input" class="text-text-primary text-base font-medium">{{ label() }}</label>
</div>

@if (addons()?.description) {
  <div class="flex items-center">
    <span class="text-text-tertiary text-sm font-normal">{{ addons()!.description }}</span>

    @if (addons()?.descriptionAction) {
      &nbsp;
      <span
        class="text-sm font-medium text-text-secondary hover:text-text-secondary-hover underline cursor-pointer"
        (click)="addons()!.descriptionAction!.callback()"
        >{{ addons()!.descriptionAction!.text }}</span
      >
    }
  </div>
}
